export default function(response) {
	let parsed = [];

	if ('errors' in response) {
		for (const field in response.errors) {
			if (Object.hasOwnProperty.call(response.errors, field)) {
				const element = response.errors[field];
				parsed.push(...element);
			}
		}
	}

	return parsed;
}
